import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, Dropdown } from '@quintoandar-tokko/jopijs';
import styles from '../filterBar.module.scss';
import Trans from '@/components/shared/Trans';
import translations from '../FilterBar.trans.json';
import { formatSelectedText } from '../utils';
import {
  UPDATED_BUCKET,
  UPDATED_BUCKET_OPTIONS,
} from '../constants/filtersConstants';
import { setSelectedIds } from '@/store/slices/components/filterBar/FilterBarSlice';
import FilterSelectControl, {
  useFilterSelection,
} from '../FilterSelectControl';

function UpdatedDropdown() {
  const dispatch = useDispatch();
  const { selectedIds } = useSelector((state) => state.FilterBarSlice.filters);
  const [selectedLocalIds, setSelectedLocalIds] = useState([]);

  const updatedTitle = Trans(translations, 'filterBarLeads.LastUpdate');

  const bucketOptions = UPDATED_BUCKET_OPTIONS.map((option) => ({
    ...option,
    text: Trans(translations, `filterBarLeads.${option.translationKey}`),
  }));

  const toggleSelection = (bucket) => {
    setSelectedLocalIds((prev) => {
      const isSelected = prev.find((x) => x.id === bucket.id);
      if (isSelected) {
        return prev.filter((x) => x.id !== bucket.id);
      }
      return [
        ...prev,
        { id: bucket.id, text: bucket.text, filter_type: UPDATED_BUCKET },
      ];
    });
  };

  const valueTextButton = formatSelectedText(
    selectedIds,
    updatedTitle,
    UPDATED_BUCKET
  );

  const handleUpdatedBucketAdd = () => {
    dispatch(
      setSelectedIds({ idList: selectedLocalIds, type: UPDATED_BUCKET })
    );
  };

  useEffect(() => {
    const updatedSelec = selectedIds.filter(
      (id) => id.filter_type === UPDATED_BUCKET
    );
    return setSelectedLocalIds(updatedSelec);
  }, [selectedIds]);

  const selection = useFilterSelection(UPDATED_BUCKET);

  return (
    <Dropdown height="auto" className={`dropdown ${styles.dropdownList}`}>
      <FilterSelectControl
        filled={selection.filled}
        pending={selectedLocalIds.length > 0}
        tooltip={selection.tooltip}
        onClear={selection.onClear}
        clearLabel={selection.clearLabel}
      >
        <Dropdown.Button
          variant="dropdownDefault"
          className={styles.dropdownButton}
          text={valueTextButton}
        />
      </FilterSelectControl>
      <Dropdown.Items height={336} clickClose className={styles.dropdownItems}>
        {bucketOptions.map((bucket) => (
          <Dropdown.Multiselect
            key={bucket.id}
            onClick={(e) => {
              e.stopPropagation();
              toggleSelection(bucket);
            }}
            active={selectedLocalIds.find((x) => x.id === bucket.id)}
            className={styles.dropdownMultiselect}
          >
            {bucket.text}
          </Dropdown.Multiselect>
        ))}
        <Box className={styles.applyButtonContainer}>
          <Button
            className={styles.applyButton}
            variant={['primary', 'small']}
            onClick={handleUpdatedBucketAdd}
          >
            {Trans(translations, 'Apply')}
          </Button>
        </Box>
      </Dropdown.Items>
    </Dropdown>
  );
}

export default UpdatedDropdown;
